import { render, staticRenderFns } from "./SocialSeriesTitle.vue?vue&type=template&id=0a2230d7&scoped=true&"
import script from "./SocialSeriesTitle.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesTitle.vue?vue&type=script&lang=js&"
import style0 from "./SocialSeriesTitle.vue?vue&type=style&index=0&id=0a2230d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2230d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2230d7')) {
      api.createRecord('0a2230d7', component.options)
    } else {
      api.reload('0a2230d7', component.options)
    }
    module.hot.accept("./SocialSeriesTitle.vue?vue&type=template&id=0a2230d7&scoped=true&", function () {
      api.rerender('0a2230d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSeriesTitle.vue"
export default component.exports